module.exports = __webpack_public_path__ + "static/dory-6eb967e25c55c61b07c48a364ad6f0b2.svg";